import analysisModule from "../analysisModule"
import restrictionsModal from "./restrictionsModal.html"
import arrays from "../../../bower_components/front-end-web-commons/app/arrays/arrays"

analysisModule.service("restrictionsModal", ["$modal", "$q", function ($modal, $q) {
    return function (vehicles, origins) {
        const paginationApi = $q.defer()
        return $modal.open({
            template: restrictionsModal,
            size: "lg",
            controller: ["$scope", "$translate", "weightFilter", "volumeFilter", function ($scope, $translate, weightFilter, volumeFilter) {
                $scope.model = {
                    headerCheck: false,
                    restrictions: {
                        vehicleIds: [],
                        originId: null
                    }
                }
                $scope.allVehicles = vehicles
                $scope.allOrigins = origins
                $scope.model.selectedOrigin = null
                $scope.filteredVehicles = arrays.copy(vehicles)
                $scope.tableOptions = {
                    columns: [
                        {
                            width: "0px",
                            header: {
                                template: "<input type='checkbox' name='selectAll' ng-change='toggleAll()' ng-model='model.headerCheck' ng-checked='allChildrenChecked()'>",
                            },
                            cell: {
                                "template": "<input type='checkbox' data-cy='{{record.sourceId}}' name='selectVehicle' ng-model='record.selected' ng-change='addOrRemoveInSelectedVehicles(record.id)'>"
                            }
                        },
                        {
                            cellName: "optimization.restrictions.vehicle.sourceId",
                            header: "optimization.restrictions.vehicle.sourceId",
                            cell: "{{ record.sourceId }} - {{record.name}}"
                        },
                        {
                            cellName: "optimization.restrictions.vehicle.max.weight",
                            header: "optimization.restrictions.vehicle.max.weight",
                            cell: "{{weightFilter(record.maxWeight)}}"
                        },
                        {
                            cellName: "optimization.restrictions.vehicle.max.volume",
                            header: "optimization.restrictions.vehicle.max.volume",
                            cell: "{{volumeFilter(record.maxVolume) }}"
                        },
                        {
                            cellName: "optimization.restrictions.vehicle.velocity",
                            header: "optimization.restrictions.vehicle.velocity",
                            cell: "{{ record.defaultSpeed }} km/h"
                        }
                    ],
                    records: [],
                    pagination: {
                        maxPageSize: 10,
                        firstResult: 0,
                        maxResults: 10,
                        count: $scope.filteredVehicles.length,
                        onPaginate: (firstResult, maxResults) => {
                            const paginated = $scope.filteredVehicles.slice(firstResult, firstResult + maxResults)
                            return {
                                result: paginated,
                                firstResult: firstResult,
                                maxResults: maxResults,
                                count: $scope.filteredVehicles.length,
                            }
                        }
                    },
                    onRegisterPagination: function (api) {
                        paginationApi.resolve(api)
                        paginationApi.promise.then(function (api) {
                            api.seekPage(1)
                        })
                    }
                }

                $scope.weightFilter = weightFilter
                $scope.volumeFilter = volumeFilter

                $scope.filter = {
                    vehicle: "all"
                }

                $scope.availableVehicles = [{
                    value: "all",
                    label: "optimization.restrictions.vehicle.all"
                }]
                var vehiclesMap = {}

                for (var i = 0; i < vehicles.length; i++) {
                    var vehicle = vehicles[i]
                    var sourceId = vehicle.sourceId
                    if (!vehiclesMap[sourceId]) {
                        vehiclesMap[sourceId] = true
                        $scope.availableVehicles.push({
                            value: sourceId,
                            label: getPresentationLabel(vehicle)
                        })
                    }
                }

                function getPresentationLabel(vehicle) {
                    if (vehicle.name === vehicle.sourceId) {
                        return vehicle.name
                    }
                    return `${vehicle.sourceId} - ${vehicle.name} `
                }

                $scope.getVehicleLabel = function (type) {
                    if (type.value === "all") {
                        return $translate.instant("optimization.restrictions.vehicle.all")
                    }
                    return type.label ? type.label : "-"
                }

                $scope.applyFilter = function () {
                    if ($scope.filter.vehicle === "all") {
                        $scope.filteredVehicles = arrays.copy($scope.allVehicles)
                    } else {
                        var selectedId = $scope.filter.vehicle
                        $scope.filteredVehicles = $scope.allVehicles.filter(function (vehicle) {
                            return vehicle.sourceId === selectedId
                        })
                    }

                    $scope.tableOptions.pagination.count = $scope.filteredVehicles.length
                    paginationApi.promise.then(function (api) {
                        api.seekPage(1)
                    })
                }

                $scope.applyFilter()

                $scope.addOrRemoveInSelectedVehicles = function (id) {
                    if (!$scope.model.restrictions.vehicleIds.includes(id)) {
                        return $scope.model.restrictions.vehicleIds.push(id)
                    }
                    arrays.remove($scope.model.restrictions.vehicleIds, id)
                }

                $scope.toggleAll = function () {

                    $scope.model.restrictions.vehicleIds = []
                    if ($scope.model.headerCheck) {
                        $scope.model.restrictions.vehicleIds = $scope.filteredVehicles.map(v => v.id)
                    }
                    $scope.filteredVehicles.forEach(vehicle => {
                        vehicle.selected = $scope.model.headerCheck
                    })
                }

                $scope.allChildrenChecked = function () {
                    let isAllSelected = $scope.model.restrictions.vehicleIds.length === vehicles.length
                    $scope.model.headerCheck = isAllSelected
                    return isAllSelected
                }

                $scope.getOrigins = function () {
                    return $scope.allOrigins || []
                }

                $scope.setLocalityId = function () {
                    if (!$scope.model.selectedOrigin) {
                        $scope.model.restrictions.originId = null
                        return
                    }
                    $scope.model.restrictions.originId = $scope.model.selectedOrigin.id
                }

                $scope.canProceed = function () {
                    return !!$scope.model.restrictions.vehicleIds.length || !!$scope.model.restrictions.originId
                }

                $scope.proceed = function () {
                    $scope.$close($scope.model.restrictions)
                }
            }]
        }).result
    }
}])